var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepTypeBlock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.4375 15.25C10.0233 15.25 9.6875 14.9142 9.6875 14.5L9.6875 9.5C9.6875 9.08579 10.0233 8.75 10.4375 8.75C10.8517 8.75 11.1875 9.08579 11.1875 9.5V14.5C11.1875 14.9142 10.8517 15.25 10.4375 15.25ZM12.8125 14.5C12.8125 14.9142 13.1483 15.25 13.5625 15.25C13.9767 15.25 14.3125 14.9142 14.3125 14.5V9.5C14.3125 9.08579 13.9767 8.75 13.5625 8.75C13.1483 8.75 12.8125 9.08579 12.8125 9.5V14.5Z",
  fill: "currentColor"
})));
export default SvgStepTypeBlock;